var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSingle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.34375 11.875C11.4752 11.875 13.2031 10.1471 13.2031 8.01562C13.2031 5.88415 11.4752 4.15625 9.34375 4.15625C7.21228 4.15625 5.48438 5.88415 5.48438 8.01562C5.48438 10.1471 7.21228 11.875 9.34375 11.875Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14.651C4.60262 13.7935 5.40276 13.0936 6.33285 12.6104C7.26294 12.1272 8.29565 11.875 9.34375 11.875C10.3919 11.875 11.4246 12.1272 12.3547 12.6104C13.2847 13.0936 14.0849 13.7935 14.6875 14.651",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSingle);
export default __webpack_public_path__ + "static/media/UserSingle.ff4a6c3b61cd3d64c1f505c6fba7c528.svg";
export { ForwardRef as ReactComponent };